var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "#1C77C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1 50.6999H28.9V31.2999H27.1V50.6999ZM31.1 57.2999H32.9V24.6999H31.1V57.2999ZM19.1 44.3999H20.9V37.5999H19.1V44.3999ZM23.1 46.6999H24.9V35.2999H23.1V46.6999ZM35.1 68.5999H36.9V13.3999H35.1V68.5999ZM15.1 42.9999H16.9V38.9999H15.1V42.9999ZM43.1 54.5999H44.9V27.3999H43.1V54.5999ZM47.1 49.3999H48.9V32.5999H47.1V49.3999ZM39.1 62.8999H40.9V19.0999H39.1V62.8999ZM51.3 44.9999H53.1V36.9999H51.3V44.9999ZM63.1 43.9999H64.9V37.9999H63.1V43.9999ZM67.1 39.0999V42.8999H68.9V39.0999H67.1ZM55.1 47.9999H56.9V33.9999H55.1V47.9999ZM59.1 45.4999H60.9V36.3999H59.1V45.4999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.c355ae3820090b0f377ba4155b685e08.svg";
export { ForwardRef as ReactComponent };